import styled from '@emotion/styled';

export default styled.div`
    &.public-interactive-body-woman-module-render-silhouette {
        overflow: hidden;

        img {
            transform-origin: center;
            transition: transform 400ms ease;
        }
    }
`;
